import gsap from "gsap";
import { ANIMATION, animateObserver, fadeIn } from "../../../js/animations/animations";
import { isAuthor, isMobile } from "../../../js/utils";
import CLASSES from "./utils/class";

(() => {
  "use strict";

  const BRHSlideGallery = () => {
    const init = () => {
      //== Animations
      if (!isMobile() && !isAuthor()) {
        const slideGalleries = document.querySelectorAll(CLASSES.elements.main);
        if (slideGalleries.length > 0) {
          slideGalleries?.forEach((element) => {
            const appearances = gsap.timeline();

            const paragraph = element.querySelectorAll(ANIMATION.selectors.animatedParagraph);
            paragraph.length > 0 && appearances.add(fadeIn({ classElement: paragraph, duration: 3 }), 0);

            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };

    init();
  };

  document.addEventListener("DOMContentLoaded", BRHSlideGallery);
})();
